<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-table
                striped
                hover
                :items="listConfiguration"
                :fields="fields"
                show-empty
                :current-page="currentPage"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
            >
                <template v-slot:cell(index)="data">{{
                    (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                }}</template>
                <template v-slot:cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button
                        class="min-width-none"
                        variant="light"
                        v-b-tooltip.hover
                        :title="$t('alert.attribute')"
                        @click="openParamModal(row.item.id)"
                    >
                        <i class="fa fa-sliders"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>{{ $t('configuration.empty') }}</span>
                    </div>
                </template>
            </b-table>
            <div v-if="countRow > CONSTANTS.ITEM_PER_PAGE" class="my-1">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="countRow"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                    :hide-goto-end-buttons="true"
                    :prev-text="$t('common.prevPage')"
                    :next-text="$t('common.nextPage')"
                    class="my-0"
                    align="center"
                ></b-pagination>
            </div>
        </div>

        <!-- Create/Edit Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="`${itemInfo.id ? $t('common.update') : $t('common.create')}`"
            :title="`${itemInfo.id ? $t('configuration.update') : $t('configuration.create')}`"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
        >
            <b-form-group :label="'Nội dung'">
                <b-form-textarea
                    rows="10"
                    v-model="itemInfo.objectValue.content"
                    :placeholder="'Nội dung'"
                />
            </b-form-group>
        </b-modal>

        <!-- Edit Configuration Params -->
        <b-modal
            ref="configurationParamsModal"
            :ok-title="$t('common.update')"
            :title="$t('configuration.configuration')"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
            body-class="scroll-modal-body"
        >
            <b-form-group label="Mực nước cao">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.waterHigh"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Mực nước trung bình">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.waterLow"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Mực nước thấp">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.waterMedium"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Mưa rất to">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.rainVeryHigh"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Mưa to">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.rainHigh"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Mưa vừa">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.rainMedium"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Mưa nhỏ">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.rainLow"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Không mưa">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.objectValue.notRain"
                    placeholder="Nhập giá trị"
                ></b-form-input>
            </b-form-group>
        </b-modal>

        <!-- Confirm Delete -->
        <!-- <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
        >{{ $t('configuration.deleteConfirmMsg') }}</b-modal>-->
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
export default {
    mounted: function () {
        this.$nextTick(function () {
            this.getList().then((response) => {
                if (response.length && response.some((item) => item.name === 'Web Parameters')) {
                    this.listConfiguration = response;
                } else {
                    this.add();
                    this.listConfiguration = this.items;
                }
            });
        });
    },
    computed: {
        ...mapState({
            items: (state) => state.configuration.items,
            item: (state) => state.configuration.item
        }),
        fields() {
            return [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'name', label: this.$t('common.name') },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$t('common.lastCreated')
                },
                {
                    thClass: 'configuration-actions-col',
                    key: 'actions',
                    label: this.$t('common.actions')
                }
            ];
        },
        countRow() {
            return this.listConfiguration.length;
        }
    },
    data() {
        return {
            itemInfo: {
                name: 'Web Parameters',
                objectValue: {}
            },
            currentId: null,
            currentPage: 1,
            listConfiguration: [],
            params1: null,
            CONSTANTS
        };
    },
    methods: {
        ...mapActions({
            getList: 'configuration/getList',
            updateOrCreate: 'configuration/updateOrCreate',
            deleteById: 'configuration/delete',
            getInfo: 'configuration/getInfo'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.itemInfo.id) {
                        this.update();
                    } else {
                        // this.add();
                    }
                    this.$refs.createOrUpdateModal.hide();
                    this.$refs.configurationParamsModal.hide();
                    this.$toaster.success(
                        `${
                            this.item.id
                                ? this.$i18n.t('common.update')
                                : this.$i18n.t('common.create')
                        } ${this.$i18n.t('configuration.holidaySuccess')}`
                    );
                }
            });
        },
        async add() {
            delete this.itemInfo.id;
            await this.updateOrCreate(this.itemInfo);
        },
        // async showUpdateModal(id) {
        //     this.resetForm();
        //     await this.getInfo({ id: id });
        //     this.itemInfo = { ...this.item };
        //     this.$refs.createOrUpdateModal.show();
        // },
        async update() {
            for (const param in this.itemInfo.objectValue) {
                this.itemInfo.objectValue[param] = this.itemInfo.objectValue[param];
            }
            await this.updateOrCreate(this.itemInfo);
        },
        // async onDelete(modal) {
        //     modal.preventDefault();
        //     await this.deleteById({ id: this.currentId });
        //     if (this.items.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentPage - 1) {
        //         this.currentPage--;
        //     }
        //     this.$refs.deleteModal.hide();
        //     this.$toaster.success(this.$i18n.t('configuration.deleteMess'));
        // },
        // async confirmDelete(zoneId) {
        //     this.currentId = zoneId;
        //     this.$refs.deleteModal.show();
        // },
        resetForm() {
            this.itemInfo = {
                name: 'Web Parameters',
                objectValue: {}
            };
        },
        async openParamModal(id) {
            this.resetForm();
            await this.getInfo({ id: id });
            this.itemInfo = _.cloneDeep(this.item);
            if (this.itemInfo.id == 2) this.$refs.configurationParamsModal.show();
            else this.$refs.createOrUpdateModal.show();
        }
    }
};
</script>
<style>
.scroll-modal-body {
    max-height: 70vh;
    overflow: auto;
}
.timepicker-popup {
    z-index: 9999 !important;
}
</style>
